export enum eReducerStatusBase {
  is_not_initialization = "is_not_initialization",
  is_loading = "is_loading",
  is_completed = "is_completed",
  is_saving = "is_saving",
  is_saved = "is_saved",
  is_deleting = "is_deleting",
  is_deleted = "is_deleted",
  is_need_reload = "is_need_reload",
  is_exporting = "is_exporting",
  is_exported = "is_exported",
}
